import React, { useEffect, useState, useCallback } from "react";
import { Button, Input, Select, Tag, Spin, Badge, Tooltip } from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./members.scss";
import "./index.scss";
import OrganizationTableHub from "../table/tableHub";
import HubPendingApprovalTable from "../table/hubPendingApprovalTable";
import Interests from "../json/interestsType.json";
import { toast } from "react-toastify";
import userServiceApi from "../../api/userServiceApi";
import { getRequest } from "../../api/http";
import backBtn from "../../assets/images/back-arrow.svg";
import FilterHub from "./filterHub";
import { useStore } from "../../store";
import { inputFieldCharLimit } from "../../config";
import { debounce } from 'lodash';
import { useLocation } from "react-router-dom";
import { enumMismatchAdaptor } from "../../utils";
import { setTabInterestName } from "../../store/actions";

const HubMember = () => {
  const navigate = useNavigate();
  const location= useLocation()
  const [isHubPending, setIsHubPending] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  sessionStorage.setItem("paeg", "hub-members");
  const count = sessionStorage.getItem("hubPending"); 

  const [masterDataIds,setMasterDataIds] = useState([])
  const [sectorNameHub, setSectorNameHub] = useState("");
  const [subSectorNameHub, setSubSectorNameHub] = useState("");
  const [hubMembersTable, setHubMemberTable] = useState([]);
  const [totalHubMembers, setTotalHubMembers] = useState();
  const [organizationName, setOrganisationName] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [sortDirectionHub, setSortDirectionHub] = useState();
  const [reviewPending, setReviewPending] = useState(false);
  const [hubPageNumber, setHubPageNumber] = useState(0);
  const [sortBy, setSortBy] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  const [showSearchBar, setShowSearchBar] = useState(true);
  const [showTags, setShowTags] = useState(true);

  const [afh, setAfh] = useState("");
  const [glh, setGlh] = useState("");
  const [msh, setMsh] = useState("");
  const [tzh, setTzh] = useState("");
  const [boolafh, setBoolAfh] = useState(false);
  const [boolglh, setBoolGlh] = useState(false);
  const [boolmsh, setBoolMsh] = useState(false);
  const [booltzh, setBoolTzh] = useState(false);
  const [ishubReview, setishubReview] = useState(false);
  const [hubreviewid, sethubreviewid] = useState();

  const { pendingHubMembersCount, deleteReviewsHubCount, dispatch } = useStore();

  const fetchMasterDataIds = useCallback(async()=>{
    const response = await getRequest(userServiceApi.getMasterDataIds())
    if(response?.data?.length){
      setMasterDataIds(response?.data)
    }
  },[])

  useEffect(()=>{
    fetchMasterDataIds()
  },[fetchMasterDataIds])

  // Ultra-strict sanitization
  const sanitizeSearchInput = (input) => {
    if (input === undefined || input === null) return '';
    if (typeof input !== 'string') return '';

    // Only allow: letters, numbers, spaces, hyphens, underscores
    const sanitized = input.replace(/[^a-zA-Z0-9\s\-_]/g, '');

    console.log('🔍 Search Sanitization - Input:', `"${input}"`, 'Output:', `"${sanitized}"`);
    return sanitized;
  };

  // Safe URL parameter encoding
  const getSafeSearchParam = (input) => {
    if (!input || input.trim() === '') return '';

    const sanitized = sanitizeSearchInput(input.trim());
    if (!sanitized) return '';

    return encodeURIComponent(sanitized);
  };

  const ReviewHandlerhub = (id) => {
    setishubReview(true);
    sethubreviewid(id);
  };

  const handleBackClickhub = () => {
    setishubReview(false);
    getHubMembers();
  };

  const reloadFunction = () => {
    getHubMembers();
  }

  const sortFunctionHub = (direction) => {
    setSortDirectionHub(direction);
  };

  const sortByFunction = (sortByValue) => {
    setSortBy(sortByValue);
  };

  const reviewPendingFunction = (reviewPendingState) => {
    setReviewPending(reviewPendingState);
    if (reviewPendingState === true) {
      getReviewPendingHubData(reviewPendingState);
    } else {
      getHubMembers();
    }
  };

  const handleHubPagNumber = (number) => {
    setHubPageNumber(number - 1);
  };

  const [interestNameHub, setinterestNameHub] = useState(null);
  const [selectedEventHub, setSelectedEventHub] = useState(null);
  const [sectorIdHub, setSectorIdHub] = useState(null);
  const [subsectorIdHub, setSubsectorIdHub] = useState(null);
  const [sizeHub, setSizeHub] = useState(null);
  const [updateFilterDataHub, setUpdateFilterDataHub] = useState(false);

  const hubMembersPendingApprovalHandler = () => {
    setIsHubPending(true);
  };

  const HideHubpendingApprovalHandler = () => {
    setIsHubPending(false);
  };

  const [reviewHubCount, setReviewHubCount] = useState([]);

  const getHubMembers = async (searchValue = null) => {
    try {
      setLoader(true);

      let safeSearchTerm = '';
      const currentSearchTerm = searchValue ?? searchTerm;

      if (currentSearchTerm && currentSearchTerm.trim() !== '') {
        safeSearchTerm = getSafeSearchParam(currentSearchTerm);
      }

      console.log('🌐 Hub Members API Call - Search Term:', {
        original: currentSearchTerm,
        safe: safeSearchTerm,
        hubPageNumber,
        pageSize
      });

      const masterDataEnum = enumMismatchAdaptor(interestNameHub)
      const masterDataId = masterDataIds?.find((e)=>e?.enumValue === masterDataEnum)?.id

      if(interestNameHub){
        dispatch(setTabInterestName(interestNameHub))
      }
      const response = await getRequest(
        userServiceApi.getAllFilterHubOrganizations(
          pageSize,
          hubPageNumber,
          interestNameHub,
          sectorIdHub,
          subsectorIdHub,
          sizeHub,
          safeSearchTerm, // Use safe search term
          sortDirectionHub,
          sortBy,
          afh,
          glh,
          msh,
          tzh,
          masterDataId
        )
      );

      if (response) {
        setHubMemberTable(response.data.result || []);
        setTotalHubMembers(response?.data?.totalCount);
        setReviewHubCount(response?.data?.result || []);
      }
    } catch (error) {
      console.error("Error fetching hub members:", error);
      toast.error(error?.error || "Failed to load hub members");
      setHubMemberTable([]);
      setReviewHubCount([]);
    } finally {
      setLoader(false);
    }
  };

  // Debounced search
  const debouncedSearch = useCallback(
    debounce((value) => {
      getHubMembers(value);
    }, 600),
    [pageSize, hubPageNumber, interestNameHub, masterDataIds, sectorIdHub, subsectorIdHub, sizeHub, sortDirectionHub, sortBy, afh, glh, msh, tzh]
  );

  // Search change handler
  const handleSearchChange = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    setSearchTerm(sanitizedValue);

    if (sanitizedValue.trim().length > 0) {
      debouncedSearch(sanitizedValue);
    } else {
      // If search is cleared, get all data
      getHubMembers('');
    }
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    getHubMembers('');
  };

  // Handle enter key press
  const handlePressEnter = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    if (sanitizedValue.trim().length > 0) {
      getHubMembers(sanitizedValue);
    }
  };

  const getReviewPendingHubData = async (reviewPendingState) => {
    try {
      setLoader(true);
      const getPendingCount = true;
      const response = await getRequest(
        userServiceApi.getReviewPendingHubData(
          getPendingCount,
          reviewPending || reviewPendingState
        )
      );

      if (response) {
        setHubMemberTable(response.data.result || []);
        setTotalHubMembers(response?.data?.totalCount);
        setReviewHubCount(response?.data?.result || []);
      }
    } catch (error) {
      console.error("Error fetching review pending hub data:", error);
      toast.error(error?.error || "Failed to load review data");
      setHubMemberTable([]);
      setReviewHubCount([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getHubMembers();
  }, [hubPageNumber, sortDirectionHub, afh, glh, msh, tzh]);

  const RemoveHandlerHub = (value) => {
    if (value === "interest") {
      setinterestNameHub(null);
      setSelectedEventHub(null);
    }
    if (value === "sector") {
      setSectorIdHub(null);
      setSubsectorIdHub(null);
    }
    if (value === "subsector") {
      setSubsectorIdHub(null);
    }
    if (value === "size") {
      setSizeHub(null);
    }
    setUpdateFilterDataHub(!updateFilterDataHub);
    getHubMembers();
  };

  const setFilterHandlerHub = async (sectorIdHub, subSectorIds, sizeHub) => {
    try {
      let selectedSubSectorHub = null
      if(sectorIdHub){
        const partnerId = sessionStorage.getItem("partnerId")

        const sectorHubResponse = await getRequest(
          userServiceApi.getAllSectors(partnerId, "SECTOR")
        );
        let selectedSectorHub = sectorHubResponse.data.find(
          (sector) => sector.id === sectorIdHub
        );
        setSectorNameHub(selectedSectorHub?.name ? selectedSectorHub?.name : "");
        
        if(subSectorIds?.length){
          const subSectorHubResponse = await getRequest(
            userServiceApi.getSubSectors(sectorIdHub, "SUB_SECTOR")
          );
          selectedSubSectorHub = subSectorHubResponse.data.find(
            (sector) => sector.id === subSectorIds
          ); 
        }
      }
      setSubSectorNameHub(
        selectedSubSectorHub?.name ? selectedSubSectorHub?.name : ""
      );
      setSubsectorIdHub(subSectorIds);
      setSectorIdHub(sectorIdHub);
      setSizeHub(sizeHub);
    } catch (error) {
      console.error("Error setting hub filters:", error);
    }
  };

  useEffect(() => {
    getHubMembers();
  }, [
    interestNameHub,
    sectorIdHub,
    subsectorIdHub,
    sizeHub,
    sortDirectionHub,
    afh,
    glh,
    msh,
    tzh,
    masterDataIds
  ]);

  const interestChangeHub = (e) => {
    setinterestNameHub(e);
    setSelectedEventHub(e);
  };

  const handleAFh = () => {
    if (!boolafh) {
      setAfh("A-F");
      setBoolAfh(true);
    } else {
      setAfh("");
      setBoolAfh(false);
    }
  };

  const handleGLh = () => {
    if (!boolglh) {
      setGlh("G-L");
      setBoolGlh(true);
    } else {
      setGlh("");
      setBoolGlh(false);
    }
  };

  const handleMSh = () => {
    if (!boolmsh) {
      setMsh("M-S");
      setBoolMsh(true);
    } else {
      setMsh("");
      setBoolMsh(false);
    }
  };

  const handleTZh = () => {
    if (!booltzh) {
      setTzh("T-Z");
      setBoolTzh(true);
    } else {
      setTzh("");
      setBoolTzh(false);
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  if (loader) {
    return (
      <div className="data-loader">
        <Spin className="spin" tip="Loading hub members..." size="large" />
      </div>
    );
  } else {
    return (
      <div className="tabContainer">
        <div className="main-container" style={{ paddingTop: "5px" }}>
          <div className="header-container">
            <div className="backbtn-container">
              <img
                src={backBtn}
                onClick={() => navigate('/partner-org')}
                alt="Back"
                style={{ cursor: 'pointer' }}
              />
              <p>Hub members</p>
            </div>
            <div className="btns">
              <div className="pending-btn">
                <Badge count={location?.state?.hubPendingcount || count || '' } showZero overflowCount={20}>
                  <Button
                    className="pending-badge"
                    onClick={() => navigate('/hub-pending', { state: { page: "hub-members" } })}
                  >
                    Pending Approvals
                  </Button>
                </Badge>
              </div>
              <div className="pending-btn">
                <Badge count={deleteReviewsHubCount} showZero overflowCount={10}>
                  <Button
                    className="pending-badge"
                    onClick={() => navigate('/hub-delete-reviews', { state: { page: "hub-members" } })}
                  >
                    Review requests
                  </Button>
                </Badge>
              </div>
            </div>
          </div>
          <div className="filters-container">
            <div className="search-bar-container">
              <Tooltip placement="top" title='Allowed: letters, numbers, spaces, hyphens (-), and underscores (_).'>
                <Input
                  size="large"
                  className="input"
                  placeholder="Search Organisation"
                  suffix={
                    searchTerm ? (
                      <CloseOutlined
                        style={{ color: "#CC0E2D", verticalAlign: "middle", cursor: 'pointer' }}
                        onClick={handleClearSearch}
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                  onChange={handleSearchChange}
                  onPressEnter={handlePressEnter}
                  value={searchTerm}
                  maxLength={inputFieldCharLimit}
                />
              </Tooltip>
            </div>
            <div className="filter-btn">
              <FilterHub
                mask={false}
                interest={selectedEventHub}
                setData={setFilterHandlerHub}
                updateFilterData={updateFilterDataHub}
                span={9}
                sector={sectorIdHub}
                subsector={subsectorIdHub}
                sizeHub={sizeHub}
              />
            </div>
            <div className="interests-container">
              <Select
                className="select-drpdwn"
                value={interestNameHub}
                placeholder="Select Interest"
                onChange={(e) => interestChangeHub(e)}
              >
                {Interests.map((Interest, i) => (
                  <Select.Option key={i} value={Interest.id}>
                    {Interest.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="alphabet-filters">
              <Button
                id="A-F-btn"
                className={`alpha-filter-btn ${boolafh ? `selected` : ``}`}
                onClick={handleAFh}
              >
                A-F
              </Button>
              <Button
                id="G-L-btn"
                className={`alpha-filter-btn ${boolglh ? `selected` : ``}`}
                onClick={handleGLh}
              >
                G-L
              </Button>
              <Button
                id="M-S-btn"
                className={`alpha-filter-btn ${boolmsh ? `selected` : ``}`}
                onClick={handleMSh}
              >
                M-S
              </Button>
              <Button
                id="T-Z-btn"
                className={`alpha-filter-btn ${booltzh ? `selected` : ``}`}
                onClick={handleTZh}
              >
                T-Z
              </Button>
            </div>
          </div>
          <div>
            {showTags ? (
              <div className="org-filter-options">
                <div className="filter-options">
                  {interestNameHub ? (
                    <Tag
                      closable
                      onClose={RemoveHandlerHub.bind(this, "interest")}
                    >
                      {interestNameHub === "APPRENTICESHIP"
                        ? "Apprenticeship"
                        : interestNameHub === "VACANCY"
                          ? "Vacancies"
                          : interestNameHub === "PRODUCT"
                            ? "Products"
                            : interestNameHub === "SERVICE"
                              ? "Service"
                              : interestNameHub === "WORK_EXPERIENCE"
                                ? "Experience of work"
                                : interestNameHub === "COURSES"
                                ? "Courses"
                                : interestNameHub === 'CONTRACTS'
                                ? "Contracts" : ""
                                }
                    </Tag>
                  ) : null}
                  {sectorIdHub ? (
                    <Tag
                      closable
                      onClose={RemoveHandlerHub.bind(this, "sector")}
                    >
                      {sectorNameHub}
                    </Tag>
                  ) : null}
                  {subsectorIdHub ? (
                    <Tag
                      closable
                      onClose={RemoveHandlerHub.bind(this, "subsector")}
                    >
                      {subSectorNameHub}
                    </Tag>
                  ) : null}
                  {sizeHub ? (
                    <Tag
                      closable
                      onClose={RemoveHandlerHub.bind(this, "size")}
                    >
                      {sizeHub === "MICRO"
                        ? "Micro"
                        : sizeHub === "SMALL"
                          ? "Small"
                          : sizeHub === "MEDIUM"
                            ? "Medium"
                            : sizeHub === "LARGE"
                              ? "Large"
                              : ""}
                    </Tag>
                  ) : null}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          {/* Pag number */}
          <OrganizationTableHub
            data={hubMembersTable}
            reloadFunction={reloadFunction}
            pagNumber={handleHubPagNumber}
            totalOrgs={totalHubMembers}
            sortFunction={sortFunctionHub}
            sortByFunction={sortByFunction}
            reviewPendingFunction={reviewPendingFunction}
            sector={sectorIdHub}
            subsector={subsectorIdHub}
            sizeHub={sizeHub}
            ReviewHandlerhub={ReviewHandlerhub}
            handleBackClickhub={handleBackClickhub}
            reviewHubCount={reviewHubCount}
          />
        </div>
      </div>
    );
  }
};
export default HubMember;